import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { Spin } from "antd";
import { useCommon } from "../context/CommonContext";

const PermissionRoute = ({ requiredAction = "can_read", children }) => {
  const { permissionMap, permissionsLoading } = useCommon();
  const location = useLocation();

  // Show loading spinner while permissions are being fetched
  if (permissionsLoading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh' 
      }}>
        <Spin size="large" />
      </div>
    );
  }

  // Normalize path (remove trailing slash)
  const path = location.pathname.replace(/\/+$/, "");
  const basePath = "/" + path.split("/")[1]; // e.g., /movies/add -> /movies

  const permissions = permissionMap[path] || permissionMap[basePath] || null;

  console.log("permissions===>",permissions)

  if (!permissions) {
    return <Navigate to="/unauthorized" replace />;
  }

  if (!permissions[requiredAction]) {
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
};

export default PermissionRoute;
